import React, { useEffect, useState } from "react";
import Layout from "../../hoc/Layout";
import catchErrors from "../../helpers/catchErrors";
import { readAll } from "../../helpers/events";
import EventList from "../../components/Events/EventsList";

const UserHome = () => {
  const [error, setError] = useState("");
  const [data, setData] = useState([]);

  useEffect(() => {
    const response = async () => {
      try {
        const response = await readAll();
        setData(response.data);
        // console.log(response);
      } catch (error) {
        catchErrors(error, setError);
      }
    };
    return response();
  }, []);
  return (
    <Layout>
      <div className="createImage"></div>
      <div className="home">
        <div className="content">
          <h2 className="secTitle">Upcoming Events on Earth</h2>
          <EventList data={data} />
        </div>
      </div>
    </Layout>
  );
};

export default UserHome;
